import { render } from "./GasReport.vue?vue&type=template&id=64f18c3e"
import script from "./GasReport.vue?vue&type=script&lang=js"
export * from "./GasReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__